import { createSelector } from '@ngrx/store';

import * as fromDashboard from '../reducers/dashboard.reducers'
import * as fromRoot from '../reducers'

export const selectDashboardRequest = createSelector(fromRoot.selectDashboardState, fromDashboard.getdashboardRequest);
export const selectDashboardRequestTotal = createSelector(fromRoot.selectDashboardState, fromDashboard.selectdashboardRequestTotal);
export const selectPushedAnnnouncements = createSelector(fromRoot.selectDashboardState, fromDashboard.getPushedAnnouncements);
export const selectUpcomingMeetings = createSelector(fromRoot.selectDashboardState, fromDashboard.getUpcomingMeetings);
export const selectMeetingsTotal = createSelector(fromRoot.selectDashboardState, fromDashboard.selectMeetingsTotal);
export const selectUpcomingEvents = createSelector(fromRoot.selectDashboardState, fromDashboard.getUpcomingEvents);
export const selectEventsTotal = createSelector(fromRoot.selectDashboardState, fromDashboard.selectEventsTotal);
export const selectAllRequests = createSelector(fromRoot.selectDashboardState, fromDashboard.getAllRequests);
export const selectResourceCenterFiles = createSelector(fromRoot.selectDashboardState, fromDashboard.getResourceCenterFiles);





// WEBPACK FOOTER //
// ./src/app/core/store/selectors/dashboard.selectors.ts